function normalizePriceValue(value) {
  return String(value || '');
}

function toggleInputValueClass(input) {
  const hasValue = String(input.value || '').trim().length > 0;
  input.classList.toggle('field__input--has-value', hasValue);
  input.closest('.field')?.classList.toggle('field--has-value', hasValue);
}

const GROWING_FILTER_PARAM = 'filter.p.m.custom.type_of_growing';

function normalizeFacetText(value) {
  return String(value || '').trim().toLocaleLowerCase();
}

function getGrowingFilterInputs() {
  return Array.from(
    document.querySelectorAll(`input[type="checkbox"][name="${GROWING_FILTER_PARAM}"]:not([id$="-no-js"])`)
  );
}

function growingFilterInputMatches(input, value) {
  const expectedValue = normalizeFacetText(value);
  const inputValue = normalizeFacetText(input.value);
  const inputLabel = normalizeFacetText(input.closest('label')?.querySelector('.facet-checkbox__label')?.textContent);

  return inputValue === expectedValue || inputLabel === expectedValue;
}

function syncGrowingFilterButtons() {
  const inputs = getGrowingFilterInputs();

  document.querySelectorAll('[data-growing-filter-value]').forEach((button) => {
    const matchingInputs = inputs.filter((input) => growingFilterInputMatches(input, button.dataset.growingFilterValue));
    const isActive = matchingInputs.some((input) => input.checked);
    const isAvailable = matchingInputs.some((input) => !input.disabled || input.checked);

    button.setAttribute('aria-pressed', String(isActive));
    button.classList.toggle('is-active', isActive);
    button.disabled = !isAvailable;
  });
}

document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-growing-filter-value]');
  if (!button || button.disabled) return;

  const matchingInput = getGrowingFilterInputs().find(
    (input) => growingFilterInputMatches(input, button.dataset.growingFilterValue) && (!input.disabled || input.checked)
  );

  if (!matchingInput) return;

  matchingInput.click();
  syncGrowingFilterButtons();
});

class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer){
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop){
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
        FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
  }

  static renderProductCount(html) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const count = (parsedHTML.getElementById('ProductCountDesktop') || parsedHTML.getElementById('ProductCount')).innerHTML
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    if (container) {
      container.innerHTML = count;
      container.classList.remove('loading');
    }
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
    syncGrowingFilterButtons();
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    })

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ]
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    form.querySelectorAll('[data-price-input][name]').forEach((input) => {
      formData.set(input.name, normalizePriceValue(input.value));
    });
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'))
      this.onSubmitForm(searchParams, event)
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event)
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();
syncGrowingFilterButtons();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.numberInputs = Array.from(this.querySelectorAll('[data-price-input]'));
    this.rangeInputs = Array.from(this.querySelectorAll('input[type="range"]'));
    this.rangeFill = this.querySelector('.facets__range-fill');

    this.numberInputs.forEach((element) => {
      element.addEventListener('input', this.onNumberInput.bind(this));
      element.addEventListener('change', this.onRangeChange.bind(this));
      toggleInputValueClass(element);
    });

    this.rangeInputs.forEach((element) => {
      element.addEventListener('input', this.onSliderInput.bind(this));
      element.addEventListener('change', this.onSliderInput.bind(this));
    });

    this.setMinAndMaxValues();
    this.updateSliderFromNumberInputs();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
    this.updateSliderFromNumberInputs();
    this.toggleNumberInputValueClasses();
  }

  onNumberInput(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
    this.updateSliderFromNumberInputs();
    toggleInputValueClass(event.currentTarget);
  }

  onSliderInput(event) {
    if (this.rangeInputs.length < 2 || this.numberInputs.length < 2) return;

    const minSlider = this.rangeInputs[0];
    const maxSlider = this.rangeInputs[1];
    const minInput = this.numberInputs[0];
    const maxInput = this.numberInputs[1];

    let minValue = Number(minSlider.value);
    let maxValue = Number(maxSlider.value);

    if (minValue > maxValue) {
      if (event.currentTarget === minSlider) {
        minValue = maxValue;
        minSlider.value = minValue;
      } else {
        maxValue = minValue;
        maxSlider.value = maxValue;
      }
    }

    minInput.value = minValue;
    maxInput.value = maxValue;
    this.setMinAndMaxValues();
    this.toggleNumberInputValueClasses();
    this.updateSliderFill();
  }

  setMinAndMaxValues() {
    const minInput = this.numberInputs[0];
    const maxInput = this.numberInputs[1];
    if (!minInput || !maxInput) return;

    const minValue = normalizePriceValue(minInput.value);
    const maxValue = normalizePriceValue(maxInput.value);

    if (maxValue) minInput.setAttribute('max', maxValue);
    if (minValue) maxInput.setAttribute('min', minValue);
    if (minValue === '') maxInput.setAttribute('min', this.getRangeMin());
    if (maxValue === '') minInput.setAttribute('max', this.getRangeMax());
  }

  adjustToValidValues(input) {
    const normalizedValue = normalizePriceValue(input.value);
    const value = Number(normalizedValue);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (normalizedValue === '') return;
    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }

  updateSliderFromNumberInputs() {
    if (this.rangeInputs.length < 2 || this.numberInputs.length < 2) return;

    const minInputValue = normalizePriceValue(this.numberInputs[0].value);
    const maxInputValue = normalizePriceValue(this.numberInputs[1].value);
    const minValue = minInputValue === '' ? this.getRangeMin() : Number(minInputValue);
    const maxValue = maxInputValue === '' ? this.getRangeMax() : Number(maxInputValue);

    this.rangeInputs[0].value = minValue;
    this.rangeInputs[1].value = maxValue;
    this.updateSliderFill();
  }

  toggleNumberInputValueClasses() {
    this.numberInputs.forEach(toggleInputValueClass);
  }

  updateSliderFill() {
    if (!this.rangeFill || this.rangeInputs.length < 2) return;

    const rangeMin = this.getRangeMin();
    const rangeMax = this.getRangeMax();
    const range = rangeMax - rangeMin;
    const minValue = Number(this.rangeInputs[0].value);
    const maxValue = Number(this.rangeInputs[1].value);

    if (range <= 0) {
      this.rangeFill.style.left = '0%';
      this.rangeFill.style.right = '0%';
      return;
    }

    const left = ((minValue - rangeMin) / range) * 100;
    const right = 100 - ((maxValue - rangeMin) / range) * 100;
    this.rangeFill.style.left = `${Math.max(0, Math.min(100, left))}%`;
    this.rangeFill.style.right = `${Math.max(0, Math.min(100, right))}%`;
  }

  getRangeMin() {
    return Number(this.dataset.rangeMin || this.rangeInputs[0]?.getAttribute('min') || 0);
  }

  getRangeMax() {
    return Number(this.dataset.rangeMax || this.rangeInputs[1]?.getAttribute('max') || this.numberInputs[1]?.getAttribute('max') || 0);
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);
